// import { Animal } from "../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall";
// import { useAnimalConsumptionById, useAnimalConsumptionByMultipleIds } from "../../Services/Agrisys_GqlDataCaller/ConsumptionCalls/consumptionSlice";

import { useAnimalConsumptionById, useAnimalConsumptionByMultipleIds } from "../../Services/Agrisys_GqlDataCaller/ConsumptionCalls/consumptionSlice";

type DayConsumption = {
  target_id: number;
  cnt: number;
  feed: {
    total: number;
    remaning: number;
  }
  water: {
    total: number;
    remaning: number;
  };
};

const aggregateConsumptions = (
  entries: { target_id: number; consumptions?: any[] }[]
): Record<number, DayConsumption> => {

  const agg = entries.reduce((acc, { target_id, consumptions }) => {
    consumptions?.forEach(consumption => {
      const componentId = consumption?.componentId;
      const milestoneDayOffset = (consumption.milestoneDayOffset ?? 0) * -1;

      if (consumption.milestoneDayOffset === undefined) return;

      if (!acc[milestoneDayOffset]) {
        acc[milestoneDayOffset] = {
          target_id,
          cnt: 0,
          feed: { total: 0, remaning: 0 },
          water: { total: 0, remaning: 0 }
        };
      }

      if (
        consumption.total === undefined ||
        consumption.progressed === undefined ||
        (consumption.progressed === 0 && consumption.total === 0)
      ) return;
      
      // Water
      if (componentId === 1) {
        acc[milestoneDayOffset].water.total += consumption.total ?? 0;
        acc[milestoneDayOffset].water.remaning += consumption.progressed ?? 0;
        return;
      }

      acc[milestoneDayOffset].cnt++;
      acc[milestoneDayOffset].feed.total += consumption.total ?? 0;
      acc[milestoneDayOffset].feed.remaning += consumption.progressed ?? 0;
    });

    return acc;
  }, {} as Record<number, DayConsumption>);

  // Fallback
  const fallback: DayConsumption = {
    target_id: -1,
    cnt: 0,
    feed: { total: 0, remaning: 0 },
    water: { total: 0, remaning: 0 }
  };

  for (let i = 0; i <= 7; i++) {
    if (!agg[i]) {
      agg[i] = { ...fallback };
    }
  }

  return agg;
};

export const useMultipleConsumptions = (animals: number[]) => { 
  const consumptionEntities = useAnimalConsumptionByMultipleIds(
    animals.map(a => a.toString())
  );

  const entries = Object.entries(consumptionEntities)
    .filter(([_, entity]) => !entity.isLoading && entity.entity !== undefined)
    .map(([animalId, entityConsumption]) => ({
      target_id: Number(animalId),
      consumptions: entityConsumption.entity?.consumptions
    }));

  return aggregateConsumptions(entries);
};

export const useSingleConsumption = (animal: number) => {
  const { entity } = useAnimalConsumptionById(animal.toString());

  const entries = entity
    ? [{ target_id: animal, consumptions: entity.consumptions }]
    : [];

  return aggregateConsumptions(entries);
};